import React from 'react';
import { Typography } from '../../../../typography';
import styles from './plain-text-column.module.scss';
export const PlainTextColumn = ({ data, colDef, }) => {
    const fieldValues = data[(colDef === null || colDef === void 0 ? void 0 : colDef.field) || 'field'];
    const plainTextColumnProp = {
        ...fieldValues,
    };
    return (React.createElement("div", { className: styles.plainTextColumnContainer, "data-testid": "plain-text-column-testid" },
        React.createElement(Typography, { className: styles.plainText, variant: "body-normal", noMargin: true }, plainTextColumnProp.text)));
};
//# sourceMappingURL=plain-text-column.js.map